<template>
<div class="content">
  <div class="header">
    <el-button @click="setRent">保存</el-button>
    <el-button @click="setComponents('CustomerRentEditor')">返回</el-button>
  </div>
  <div class="body">
    <el-descriptions size="mini" direction="vertical" :column="1" border>
      <el-descriptions-item label="房产转/退租">
        <el-row :gutter="5">
          <el-col :span="12">
            <el-descriptions title="现承租人信息" size="mini" :column="1" border>
              <el-descriptions-item label="承租人姓名">
                {{from_data.rent_customer_name}}
              </el-descriptions-item>
              <el-descriptions-item label="新地址">
                <el-input size="mini" v-model="from_data.new_address"></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="新联系方式">
                <el-input size="mini" v-model="from_data.new_contact_info"></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="出门证">
                <el-input size="mini" v-model="from_data.move_house_card"></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="现承租人退租时间">
<!--                <el-input size="mini" v-model="from_data.cease_date"></el-input>-->
                <el-date-picker
                  style="width: 150px"
                  v-model="from_data.old_cease_date"
                  size="mini"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-descriptions-item>
              <el-descriptions-item label="搬家时间">
<!--                <el-input size="mini" v-model="from_data.move_house_date"></el-input>-->
                <el-date-picker
                  style="width: 150px"
                  v-model="from_data.move_house_date"
                  size="mini"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-descriptions-item>
              <el-descriptions-item label="转租时间">
<!--                <el-input size="mini" v-model="from_data.t"></el-input>-->
                <el-date-picker
                  style="width: 150px"
                  v-model="from_data.transfer_date"
                  size="mini"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-descriptions-item>
            </el-descriptions>
          </el-col>
          <el-col :span="12">
            <el-descriptions title="新承租人信息(如退租，请勿填写以下内容)" size="mini" :column="1" border>
              <el-descriptions-item label="承租人姓名">
                <div>
                  <el-input v-model="from_data2.rent_customer_name" readonly style="width: 200px"></el-input>
                  <el-button size="mini" @click="selectUser">选择客户</el-button>
<!--                  <el-button size="mini" icon="el-icon-user-solid" circle title="新增客户" @click="addCustomer(1)"></el-button>-->
<!--                  <el-button size="mini" icon="el-icon-s-home" circle title="新增企业" @click="addCustomer(2)"></el-button>-->
                </div>
                <div>
                  <el-checkbox v-model="from_data2.is_change_house_charge_standard_customer" :true-label="1" :false-label="0">修改收费对象</el-checkbox>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="合同编号">
                <el-input size="mini" v-model="from_data2.contract_id" clearable></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="承租时间">
                <el-date-picker
                  style="width: 150px"
                  v-model="from_data2.begin_date"
                  size="mini"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-descriptions-item>
              <el-descriptions-item label="入住时间">
                <el-date-picker
                  style="width: 150px"
                  v-model="from_data2.move_in_date"
                  size="mini"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-descriptions-item>
              <el-descriptions-item label="入住人数">
                <el-input size="mini" v-model="from_data2.person_count" clearable></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="新承租人退租时间">
                <el-date-picker
                  style="width: 150px"
                  v-model="from_data2.cease_date"
                  size="mini"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-descriptions-item>
            </el-descriptions>
          </el-col>
        </el-row>
      </el-descriptions-item>
    </el-descriptions>
  </div>
  <AddCustomerWindow ref="AddCustomerWindow" />
  <ErpRoomUser ref="ErpRoomUser" />
</div>
</template>

<script>
import ErpRoomUser from "../../../Common/ErpRoomUser";
import AddCustomerWindow from "../../../Common/AddCustomerWindow";

export default {
  name: "CustomerRentChange",
  components:{ErpRoomUser, AddCustomerWindow},
  inject:["mainObj","setComponentsId"],
  data(){
    return{
      where:{
        id:"",
        house_id:"",
        house_name:"",
      },
      from_data:{
        id:"",
        customer_id:"",
        house_id:"",
        is_main_house:"",
        contract_id:"",
        rent_customer_id:"",
        begin_date:"",
        is_ceased:"",
        cease_date:"",
        cause:"",
        remark:"",
        new_address:"",
        new_contact_info:"",
        move_house_card:"",
        move_house_date:"",
        rent_contract_id:"",
        person_count:"",
        usage:"",
        move_in_date:"",
        sublet_date:"",
        security_remark:"",
        is_change_house_charge_standard_customer:"",
        file_id:"",
        is_merge:"",
        db_id:"",
        sub_id:"",
        op_user_id:"",
        rent_customer_type:[],
        customer_name:"",
        rent_customer_name:"",
        house_name:"",
        rent_customer_organization:"",
        rent_customer_sex:"",
        rent_customer_class:"",
        credentials_type:"",
        credentials_code:"",
        birthday:"",
        home_addresshome_address:"",
        contact_number:"",
        emergency_contact:"",
        emergency_number:"",
        old_cease_date:"",
        transfer_date:""
      },
      from_data2:{
        id:"",
        customer_id:"",
        house_id:"",
        is_main_house:"",
        contract_id:"",
        rent_customer_id:"",
        begin_date:"",
        is_ceased:1,
        cease_date:"",
        cause:"",
        remark:"",
        new_address:"",
        new_contact_info:"",
        move_house_card:"",
        move_house_date:"",
        rent_contract_id:"",
        person_count:"",
        usage:"",
        move_in_date:"",
        sublet_date:"",
        security_remark:"",
        is_change_house_charge_standard_customer:"",
        file_id:"",
        is_merge:"",
        db_id:"",
        sub_id:"",
        op_user_id:"",
        rent_customer_type:[],
        customer_name:"",
        rent_customer_name:"",
        house_name:"",
        rent_customer_organization:"",
        rent_customer_sex:"",
        rent_customer_class:"",
        credentials_type:"",
        credentials_code:"",
        birthday:"",
        home_addresshome_address:"",
        contact_number:"",
        emergency_contact:"",
        emergency_number:"",
        old_cease_date:"",
        transfer_date:""
      },
    }
  },
  activated() {
    this.where.house_id=this.house_id;
    this.where.house_name=this.house_name;
    this.where.id=this.rent_id;
    this.getRent()
  },
  watch:{
    rent_id(n,o){
      this.where.id=n;
    },
    house_id(n,o){
      this.where.house_id=n;
    }
  },
  computed:{
    rent_id(){
      return this.mainObj.rent_id
    },
    house_name(){
      return this.mainObj.house_name
    },
    house_id(){
      return this.mainObj.house_id
    },
  },
  methods:{
    setComponents(componentsId){
      this.setComponentsId(componentsId)
    },
    getRent(){
      const that=this;
      let where=ERP.reJson(that.where)
      ERP.postRequest({url:"admin/HouseRent/getRent",data:where},ret=>{
        if(ret.code){
          let from_data=ret.data
          from_data.rent_customer_type=(from_data.rent_customer_type||'').split(",")
          from_data.is_ceased=0;
          that.from_data=from_data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    setRent(){
      const that=this;
      let from_data1=ERP.reJson(that.from_data)
      let from_data2=ERP.reJson(that.from_data2)

      that.mainObj.now_customer_id=that.from_data.rent_customer_id||0;
      that.mainObj.new_customer_id=that.from_data2.rent_customer_id||0;
      ERP.postRequest({
        url:"admin/HouseRent/setRentTransfer",
        data:{
          from_data1:JSON.stringify(from_data1),
          from_data2:JSON.stringify(from_data2)
        }
      },ret=>{
        if(ret.code){
          if((ret.data||{}).new_rent_id){
            that.mainObj.rent_id=(ret.data||{}).new_rent_id
          }else {
            that.mainObj.new_customer_id=that.from_data.customer_id;
          }
          that.$message.success("保存成功")
          // that.$confirm('当前的租户已经变更成功，下一步将跳转进行账单结转！', '提示', {
          //   confirmButtonText: '下一步',
          //   cancelButtonText: '取消',
          //   type: 'warning'
          // }).then(() => {
          //   that.setComponents("SaleCarryOver")
          // }).catch(() => {
          //   that.$message.error('您当前放弃了账单结转')
          // });
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    addCustomer(type=1){
      const that=this;
      that.$refs.AddCustomerWindow.show(type,data=>{
        that.from_data2.rent_customer_id=data.customer_id;
        that.from_data2.rent_customer_name=data.name;
        that.$forceUpdate()
      })
    },
    selectUser(){
      const that=this;
      that.$refs.ErpRoomUser.show(data=>{
        that.from_data2.rent_customer_id=data.id;
        that.from_data2.rent_customer_name=data.name;
      },"")
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/CustomerRentChange.vue